var React = require('react');

function Shades (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"shades","fill":"#C4C4C4","d":"M5.104 0h344.037v318H5.104z","key":0}),React.createElement("g",{"className":"handle","key":1},[React.createElement("rect",{"width":"359.35","height":"12","y":"317","fill":"#C4C4C4","rx":"6","key":0}),React.createElement("path",{"stroke":"#C4C4C4","strokeWidth":"5","d":"M177 327v15.5","key":1}),React.createElement("path",{"stroke":"#C4C4C4","strokeWidth":"5","d":"M178.667 342c0 .84-.28 1.522-.632 1.954-.349.427-.698.546-.951.546-.254 0-.603-.119-.952-.546-.352-.432-.632-1.114-.632-1.954 0-.84.28-1.522.632-1.954.349-.427.698-.546.952-.546.253 0 .602.119.951.546.352.432.632 1.114.632 1.954z","key":2})])]);
}

Shades.defaultProps = {"className":"project","fill":"none","viewBox":"0 0 360 347"};

module.exports = Shades;

Shades.default = Shades;
